/* Custom js here */
$(document).ready(function() {
    document.addEventListener("change", function(e) {
        var parent = e.target;
        var add_btn = $(parent).closest(".product-form").find(".product-form__add-button");
        //var add_more_btn = $(parent).closest(".product-form").find(".shopify-payment-button__more-options")
        var checked_cart_num = $(parent).closest(".product-form").find(".block-swatch-list .block-swatch__radio:checked").length;
        if(checked_cart_num > 0) {
          add_btn.prop("disabled", false);
          //add_more_btn.prop("disabled", false);
        }
      });

  $(document).on("click", "#cart_email_modal_mobile", function () {
    $("#cart_form").modal();
    //console.log("index:", i)

    var main_cart_url = location.origin + "/cart/";
    $("#mini-cart-form .line-item").each(function () {
      var index = parseInt($(this).attr("index"));
      var items_len = $("#mini-cart-form .line-item").length;
      var params =
        $(this).attr("item_id") +
        ":" +
        $(this).find(".quantity-selector__input").attr("value");
      if (items_len != index) {
        main_cart_url = main_cart_url + params + ",";
      } else {
        main_cart_url = main_cart_url + params + "?storefront=true";
      }

      $("#cart_permalink").val(main_cart_url);
    });
  });
  $(document).on("click", "#cart_email_modal_desktop", function () {
    console.log('evt')
    $("#cart_form").modal();

    var main_cart_url = location.origin + "/cart/";
    $(".line-item-table__list .line-item").each(function () {
      var index = parseInt($(this).attr("index"));
      var items_len = $(".line-item-table__list .line-item").length;
      var params =
        $(this).attr("item_id") +
        ":" +
        $(this).find(".quantity-selector__input").attr("value");
      console.log("===params===", params);
      if (items_len != index) {
        main_cart_url = main_cart_url + params + ",";
        console.log("===params 1===", main_cart_url);
      } else {
        main_cart_url = main_cart_url + params + "?storefront=true";
        console.log("===params 2===", main_cart_url);
      }

      $("#cart_permalink").val(main_cart_url);
    });
  });

  document.querySelector('.js-cart-share-form')?.addEventListener('submit', async e => {
    e.preventDefault()
    const submitButton = e.target.querySelector('.js-btn-submit')
    submitButton.setAttribute('disabled', true)

    const formData = JSON.parse(JSON.stringify(Object.fromEntries(new FormData(e.target))));

    const cart = await fetch('/cart.js')
      .then(res => res.json())

    const items = cart.items.map(item => ({
      image: item.image,
      sku: item.sku,
      title: item.title,
      product_title: item.product_title,
      variant_title: item.variant_title,
      handle: item.handle,
      vendor: item.vendor,
      price: item.final_price,
      line_price: item.final_line_price,
      url: `${window.location.origin}${item.url}`,
      quantity: item.quantity
    }))

    const payload = {
      ...formData,
      cart: {
        total_price: cart.total_price,
        currency: cart.currency,
        items
      }
    }

    await fetch(e.target.getAttribute('action'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.json())

    e.target.querySelectorAll('input').forEach(input => input.value = '')
    e.target.querySelectorAll('textarea').forEach(textarea => textarea.value = '')

    $.modal.close();
    submitButton.removeAttribute('disabled')

    $(".cart-share-recipient-email").text(payload['recipient_email']);
    $("#success_email_modal_id").modal();
  })

  $(document).on("click", "#success_modal_close", function () {
    $.modal.close();
  });
})
